import { InputAdornment, InputAdornmentProps } from "@mui/material";

export type SHInputAdornmentProps = InputAdornmentProps;
export const SHInputAdornment = (props: SHInputAdornmentProps): JSX.Element => (
  <InputAdornment {...props} />
);
